import { useState } from "react";

// Texte tronqué avec « … » quand il dépasse — un clic (ou Entrée) affiche le texte complet, un autre le réduit.
// Accepte soit `text` (chaîne) soit `children` (contenu mixte, ex. texte + badge).
export default function ExpandableText({ text, children, className = "", testId }) {
  const [open, setOpen] = useState(false);
  const toggle = (e) => {
    e.stopPropagation();
    setOpen((o) => !o);
  };
  const hint = text || (typeof children === "string" ? children : "");
  return (
    <span
      role="button"
      tabIndex={0}
      data-testid={testId}
      title={open ? "Cliquer pour réduire" : hint ? `Cliquer pour tout voir : ${hint}` : "Cliquer pour tout voir"}
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") toggle(e);
      }}
      className={`${className} ${open ? "whitespace-normal break-all" : "truncate"} cursor-pointer transition-opacity hover:opacity-75`}
    >
      {children ?? text}
    </span>
  );
}
